module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main